/**
 * THE ONE TAPELLIGENCE WEBSITE ADDRESS. One field, super admin only: it is what
 * the small "By Tapelligence" logo at the foot of every player page opens.
 * Clear it in one tap and the logo stays, without a link.
 */
import { useEffect, useState } from 'react';
import { ExternalLink, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../../lib/api';

export const GoalBrandLinkBar = () => {
    const [url, setUrl] = useState('');
    const [loaded, setLoaded] = useState(false);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const res = await api.get('/goal-game/admin/tapelligence-link');
                setUrl(res.data.url || '');
                setLoaded(true);
            } catch (_e) { setLoaded(false); }
        })();
    }, []);

    const save = async (value) => {
        if (busy) return;
        setBusy(true);
        try {
            const res = await api.put('/goal-game/admin/tapelligence-link', { url: value });
            setUrl(res.data.url || '');
            toast.success(res.data.url ? 'Saved' : 'Link cleared');
        } catch (_e) { toast.error('Could not save'); } finally { setBusy(false); }
    };

    if (!loaded) return null;

    return (
        <div data-testid="gg-brand-link-bar"
             className="flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 dark:border-slate-700 px-4 py-3">
            <span className="text-sm font-semibold inline-flex items-center gap-1.5">
                <ExternalLink className="w-3.5 h-3.5" />Tapelligence website
            </span>
            <input type="url" value={url} onChange={(e) => setUrl(e.target.value)}
                   placeholder="https://tapelligence.com"
                   data-testid="gg-brand-link-input"
                   className="min-w-[240px] flex-1 rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 py-1.5 text-sm" />
            <button type="button" onClick={() => save(url)} disabled={busy}
                    data-testid="gg-brand-link-save"
                    className="inline-flex items-center gap-2 rounded-lg bg-slate-900 px-3 py-1.5 text-sm font-semibold text-white dark:bg-white dark:text-slate-900 disabled:opacity-50">
                {busy ? <Loader2 size={13} className="animate-spin" /> : null}Save
            </button>
            <button type="button" onClick={() => save('')} disabled={busy}
                    data-testid="gg-brand-link-clear"
                    className="rounded-lg border border-slate-300 dark:border-slate-700 px-3 py-1.5 text-sm font-semibold text-muted-foreground disabled:opacity-50">
                Clear
            </button>
            <span className="text-xs text-muted-foreground">
                The small logo at the foot of every player page opens this.
            </span>
        </div>
    );
};

export default GoalBrandLinkBar;
